<template>
  <div class="content-map-num">
    <div class="stats-cards">
      <div 
        class="stat-card" 
        v-for="(stat, index) in statsData" 
        :key="index"
      >
        <div class="card-content">
          <div class="stat-value">{{ formatValue(stat.value) }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentMapNum',
  data() {
    return {
      statsData: [
        {
          label: '合作诊所',
          value: 19074
        },
        {
          label: '云诊所',
          value: 2394
        },
        {
          label: '实时处方数',
          value: 53710
        },
        {
          label: '实时收入(元)',
          value: 2664172
        }
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    formatValue(value) {
      // 添加千分位分隔符
      return value.toLocaleString('zh-CN')
    },
    loadData() {
      // 这里可以调用接口获取统计数据
      // this.$http.post(process.env.VUE_APP_API_HOST + "/content_map_num", {
      //   "extra_params": {}
      // }).then((res) => {
      //   if (res.data && res.data.data) {
      //     this.statsData = res.data.data
      //   }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-map-num {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;

  .stats-cards {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    gap: 20px;

    .stat-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 15px;
      position: relative;
      border: 1px solid #48dbfb;
    //   border-radius: 4px;
        border: 1px solid rgba(96, 252, 178, 0.4);
      background: url("../../../assets/large/border.png") rgba(96, 252, 178, 0.05);
      background-size: 100% 100%;
    //   background: rgba(0, 0, 0, 0.3);
      overflow: visible;
      
      // 四个角的L形装饰
    //   &::before,
    //   &::after {
    //     content: '';
    //     position: absolute;
    //     width: 12px;
    //     height: 12px;
    //     border: 2px solid #48dbfb;
    //     z-index: 2;
    //   }
      
      // 左上角
    //   &::before {
    //     top: -2px;
    //     left: -2px;
    //     border-right: none;
    //     border-bottom: none;
    //   }
      
      // 右下角
    //   &::after {
    //     bottom: -2px;
    //     right: -2px;
    //     border-left: none;
    //     border-top: none;
    //   }
      
      .card-content {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        
        // 右上角和左下角通过内部元素的伪元素实现
        // &::before,
        // &::after {
        //   content: '';
        //   position: absolute;
        //   width: 12px;
        //   height: 12px;
        //   border: 2px solid #48dbfb;
        //   z-index: 2;
        // }
        
        // 右上角
        // &::before {
        //     top: -23px;
        //     right: -17px;
        //   border-left: none;
        //   border-bottom: none;
        // }
        
        // 左下角
        // &::after {
        //     bottom: -23px;
        //     left: -18px;
        //   border-right: none;
        //   border-top: none;
        // }
      }

      .stat-value {
        font-size: 24px;
        font-weight: bold;
        color: #F5E447; // 黄色
        line-height: 1.2;
        margin-bottom: 8px;
        text-align: center;
        letter-spacing: 0.5px;
      }

      .stat-label {
        font-size: 14px;
        color: #FFFFFF;
        line-height: 1.2;
        font-weight: 400;
        opacity: 0.7;
        text-align: center;
      }
    }
  }
}

@media (max-width: 1400px) {
  .content-map-num {
    padding: 15px;
    
    .stats-cards {
      gap: 10px;
      
      .stat-card {
        padding: 15px 10px;
        
        .stat-value {
          font-size: 20px;
        }
        
        .stat-label {
          font-size: 12px;
        }
      }
    }
  }
}
</style>

